/**
 * Builds a WhatsApp chat URL with a safely encoded prefilled message.
 *
 * @param number International phone number. Formatting characters are removed.
 * @param text Message displayed in the WhatsApp compose box.
 */
export function createWhatsAppUrl(number: string, text: string): string {
  const normalizedNumber = number.replace(/\D/g, '');

  return `https://wa.me/${normalizedNumber}?text=${encodeURIComponent(text)}`;
}
